// extracted by mini-css-extract-plugin
export default {"title":"ResetPasswordForm_title__8OTOv","form":"ResetPasswordForm_form__qaYjS","actions":"ResetPasswordForm_actions__lqyjI","linkWrap":"ResetPasswordForm_linkWrap__X+-Jy"};